function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import styled from 'styled-components';
import { Link as LinkOrg } from 'react-router-dom';
const Button = styled.button.withConfig({
  displayName: "UniversalLink__Button",
  componentId: "kk5dnx-0"
})([""]);
const Link = styled(LinkOrg).withConfig({
  displayName: "UniversalLink__Link",
  componentId: "kk5dnx-1"
})([""]);
const ExternalLink = styled.a.withConfig({
  displayName: "UniversalLink__ExternalLink",
  componentId: "kk5dnx-2"
})([""]);
const UniversalLink = _ref => {
  let {
      href,
      target,
      to
    } = _ref,
    props = _objectWithoutProperties(_ref, ["href", "target", "to"]);
  if (href) {
    return React.createElement(ExternalLink, _extends({}, props, {
      href: href,
      target: target,
      rel: target === '_blank' ? 'noreferrer noopener' : null
    }));
  }
  if (to) {
    return React.createElement(Link, _extends({
      to: to
    }, props));
  }
  return React.createElement(Button, props);
};
export default UniversalLink;